import { render, staticRenderFns } from "./EditableCoOwnersList.vue?vue&type=template&id=eb52b25a"
import script from "./EditableCoOwnersList.vue?vue&type=script&lang=ts"
export * from "./EditableCoOwnersList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports